import type { EXPERIMENT_STATUSES } from 'definitions';
import { PRE_START_STATUSES } from 'definitions';

type ExperimentStatus = (typeof EXPERIMENT_STATUSES)[number];
type PreStartStatus = (typeof PRE_START_STATUSES)[number];

/**
 * Whether an experiment has not gone live yet: a Draft, or a Draft in QA. Everything that
 * edits, plans, schedules or starts a Draft asks this rather than `status === 'Draft'`, so QA
 * cannot be locked out of something a Draft may do.
 */
export const isPreStart = (status: string | null | undefined): status is PreStartStatus =>
  (PRE_START_STATUSES as readonly string[]).includes(status ?? '');

export type { ExperimentStatus };
